import FiltersService, { FilterMessage } from 'cio/services/filters';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { task } from 'ember-concurrency';
import { actionTypeName } from 'cio/utils/action-info';
import { Channel } from 'cio/utils/metrics/common';
import ActionModel from 'cio/models/action';

export default class DemoFiltersService extends FiltersService {
  @service store!: DS.Store;

  request = task({ drop: true }, async () => {
    // Find actions and campaigns (the one demo campaign, really) in the store
    // and serialize them into the same format that the real /filters endpoint
    // would return.
    // This is so that message condition dropdowns can show the messages that
    // are being added in the demo VWB.
    let messagingActions = this.store
      .peekAll('action')
      .toArray()
      .filter((a) => a.isMessagingType);

    let messageFilters = messagingActions.reduce<Partial<FilterMessage>[]>((acc, action) => {
      if (action.isSplitTest) {
        return acc;
      }

      let message: Partial<FilterMessage> = {
        action_id: action.id,
        campaign_id: action.belongsTo('campaign').id(),
        can_segment_on_variation: false,
        output_id: action.id,
        subject: action.name,
        template_id: '0',
        type: actionTypeName(action.type) as Channel,
      };

      if (action.isVariation) {
        let parentSplit = action.belongsTo('parentAction').value() as ActionModel | null;

        if (parentSplit == null) {
          return acc;
        }

        let variationIndex = ((parentSplit.hasMany('actions').value()?.toArray() ?? []) as ActionModel[]).findIndex(
          (a) => a.id === action.id,
        );

        message.variation = variationIndex + 1;
      }

      return [...acc, message];
    }, []);

    let campaigns = this.store
      .peekAll('campaign')
      .toArray()
      .map((c) => ({
        id: c.id,
        name: c.name,
        state: c.state,
        type: c.type,
      }));

    return {
      campaigns,
      newsletters: [],
      messages: messageFilters,
      transactional_messages: [],
    };
  });
}
